"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaNavigationMenu = void 0;
var _toggleMenuFlyout = require("@ori-events/toggle-menu-flyout");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _navigation = require("../../context/navigation");
var _BeautyAndTrends = require("../BurgerMenu/BeautyAndTrends");
var _FindYourProduct = require("../BurgerMenu/FindYourProduct/FindYourProduct");
var _styles = require("../BurgerMenu/styles");
var _constants2 = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TopAreaNavigationMenu = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    activeMenu,
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const {
    shopSectionItems
  } = (0, _navigation.useBurgerMenu)();
  const beautyTipsItem = (0, _react.useMemo)(() => shopSectionItems.find(item => item.linkType === 'BeautyTips'), [shopSectionItems]);
  const onClickOverlay = (0, _react.useCallback)(() => {
    toggleActiveMenu('');
  }, [toggleActiveMenu]);
  if (!_constants.TopAreaNavigationMenus.includes(activeMenu)) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.Root, {
    "data-testid": getTestId(_constants2.TOP_AREA_NAVIGATION_MENU),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.BurgerMenuInner, {
      children: [activeMenu === _toggleMenuFlyout.MenuTypes.BeautyTipsMenu ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BeautyAndTrends.BeautyAndTrends, {
        content: beautyTipsItem?.children
      }) : null, activeMenu === _toggleMenuFlyout.MenuTypes.InspirationMenu ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FindYourProduct.FindYourProduct, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuBackdrop, {
        open: true,
        "data-testid": getTestId(_constants2.TOP_AREA_NAVIGATION_MENU_BACKDROP),
        onClick: onClickOverlay
      })]
    })
  });
};
exports.TopAreaNavigationMenu = TopAreaNavigationMenu;
